import './src/styles/global.css';

/*export const wrapRootElement = ({ element }) => (
  <BookingContextProvider>{element}</BookingContextProvider>
);*/

const GTM_ID = 'GTM-M9W8PM3';
let gtmLoaded = false;

// Initialize dataLayer early so events can be queued before GTM loads
if (typeof window !== 'undefined') {
  window.dataLayer = window.dataLayer || [];
}

function loadScript(src, id, onload) {
  if (document.getElementById(id)) {
    return;
  }

  var script = document.createElement('script');
  script.async = true;
  script.src = src;
  script.id = id;
  script.onload = onload;
  document.body.appendChild(script);
}

/**
 * Load Google Tag Manager after page has loaded
 * This improves performance by not blocking initial page render
 */
function loadGTM() {
  if (gtmLoaded || typeof window === 'undefined') {
    return;
  }

  // Ensure dataLayer exists (should already be initialized)
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });

  // Load GTM script
  const gtmScript = document.createElement('script');
  gtmScript.async = true;
  gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
  gtmScript.id = 'google-tagmanager';
  document.head.appendChild(gtmScript);

  // Add GTM noscript iframe
  const noscript = document.createElement('noscript');
  const iframe = document.createElement('iframe');
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';
  noscript.appendChild(iframe);
  document.body.insertBefore(noscript, document.body.firstChild);

  gtmLoaded = true;
}

/**
 * Load GTM after page is interactive
 * Uses requestIdleCallback if available, otherwise falls back to setTimeout
 */
function deferGTMLoading() {
  if (typeof window === 'undefined') {
    return;
  }

  // Wait for page to be interactive
  if (document.readyState === 'complete') {
    // Use requestIdleCallback for better performance, with fallback
    if (window.requestIdleCallback) {
      window.requestIdleCallback(
        () => {
          // Additional delay to ensure page is fully loaded
          setTimeout(loadGTM, 2000);
        },
        { timeout: 5000 },
      );
    } else {
      // Fallback for browsers without requestIdleCallback
      setTimeout(loadGTM, 2000);
    }
  } else {
    // Wait for page load event
    window.addEventListener('load', () => {
      if (window.requestIdleCallback) {
        window.requestIdleCallback(
          () => {
            setTimeout(loadGTM, 2000);
          },
          { timeout: 5000 },
        );
      } else {
        setTimeout(loadGTM, 2000);
      }
    });
  }
}

// Initialize GTM loading on client-side mount
export const onClientEntry = () => {
  deferGTMLoading();
};

export const onRouteUpdate = ({ location, pageContext }) => {
  if (
    location.search.includes('_storyblok') &&
    location.search.includes('token')
  ) {
    loadScript(
      '//app.storyblok.com/f/storyblok-v2-latest.js',
      'storyblok-javascript-bridge-v2',
      () => {
        console.log('Storyblok Bridge has been loaded');
      },
    );
  }
};
